// extracted by mini-css-extract-plugin
export default {"landing-page-upper":"unautorisedNavBar_landing-page-upper__bQCsv"};